import React, { useState } from 'react';

const DynamicBulletInput = ({
  title = 'Enter Items',
  placeholder = 'Enter item',
  onChange,
  items = [],
  description = '',
  maxItems = 10,
  validateItem = (item) => item.trim() !== '',
  status
}) => {
  const handleChange = (index, value) => {
    const updated = [...items];
    updated[index] = value;
    onChange(updated, description);
  };

  const handleDescriptionChange = (e) => {
    onChange(items, e.target.value);
  };

  const addItem = () => {
    if (items.length < maxItems) {
      onChange([...items, ''], description);
    }
  };

  const removeItem = (index) => {
    const updated = [...items];
    updated.splice(index, 1);
    onChange(updated, description);
  };

  return (
    <div>
      <h5 className="text-xl font-bold mb-4">{title}</h5>

      <div className="mb-4">
        <textarea
          className="w-full border p-2 rounded"
          placeholder="Add a description..."
          style={{ width: "90%" }}
          value={description}
          onChange={handleDescriptionChange}
          rows={3}
          disabled={status=='approved'}
        />
      </div>

      {items.map((item, index) => (
        <div key={index} className="flex items-center gap-2 mb-2">
          <input
            type="text"
            style={{ width: "90%" }}
            className={`border p-2 rounded focus:outline-none focus:ring-2 ${
              !validateItem(item) ? 'border-red-500' : 'border-gray-300'
            }`}
            value={item}
            onChange={(e) => handleChange(index, e.target.value)}
            placeholder={`${placeholder} ${index + 1}`}
          />
          <button type="button" onClick={() => removeItem(index)} className="ml-2" >
            ✕
          </button>
        </div>
      ))}

      {items.length < maxItems && (
        <button
          type="button"
          onClick={addItem}
          className="bg-blue-600 text-black px-4 py-2 rounded hover:bg-blue-700"
          disabled={status=='approved'}
        >
          + Add
        </button>
      )}

      {(items.some((i) => validateItem(i)) || description.trim()) && (
        <div className="mt-6">
          
          {description.trim() && (
            <div className="mt-2">
              <h6 className="text-md font-semibold mb-1">Description:</h6>
              <p className="pl-1">{description}</p>
            </div>
          )}
          <ul className="list-disc pl-5 space-y-1">
            {items.filter((i) => validateItem(i)).map((i, idx) => (
              <li key={idx}>{i}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default DynamicBulletInput;
